import React from 'react';

const ScoreWidget = ({ score, hasApport, hasBudget }) => {
  // Cas "données insuffisantes" : aucun champ qualifiant n'est rempli
  if (score === null || score === undefined) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6" data-testid="score-widget-empty">
        <h3 className="text-sm font-bold text-slate-800 mb-4">Score Faisabilité</h3>
        <div className="text-center py-3">
          <div className="text-5xl font-bold text-slate-300 mb-1.5">
            —<span className="text-2xl">/100</span>
          </div>
          <p className="text-sm text-slate-500 italic">Données insuffisantes</p>
          <p className="text-xs text-slate-400 mt-2">Renseignez le budget, les villes, les types de biens<br/>ou la capacité financière pour activer le score.</p>
        </div>
      </div>
    );
  }

  const getScoreLabel = (score) => {
    if (score >= 80) return 'Projet très solide';
    if (score >= 60) return 'Projet prometteur';
    return 'À consolider';
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6" data-testid="score-widget">
      <h3 className="text-sm font-bold text-slate-800 mb-4">Score Faisabilité</h3>
      
      <div className="text-center mb-4">
        <div className="text-5xl font-bold text-green-600 mb-1.5">
          {score}<span className="text-2xl">/100</span>
        </div>
        <p className="text-sm text-slate-600">{getScoreLabel(score)}</p>
      </div>

      <div className="space-y-3">
        <div className={`flex items-center justify-between p-3 rounded-lg border ${hasApport ? 'bg-green-50 border-green-200' : 'bg-slate-50 border-slate-200'}`}>
          <div className="flex items-center gap-2">
            <i className={`bi ${hasApport ? 'bi-check-circle-fill text-green-600' : 'bi-clock text-slate-400'}`}></i>
            <span className="text-sm font-semibold text-slate-700">Financement</span>
          </div>
          <span className={`text-xs font-bold px-2 py-1 rounded-full ${hasApport ? 'text-green-700 bg-green-100' : 'text-slate-600 bg-slate-100'}`}>
            {hasApport ? 'Validé' : 'En attente'}
          </span>
        </div>
        
        <div className={`flex items-center justify-between p-3 rounded-lg border ${hasBudget ? 'bg-blue-50 border-blue-200' : 'bg-slate-50 border-slate-200'}`}>
          <div className="flex items-center gap-2">
            <i className={`bi ${hasBudget ? 'bi-check-circle-fill text-blue-600' : 'bi-clock text-slate-400'}`}></i>
            <span className="text-sm font-semibold text-slate-700">Budget défini</span>
          </div>
          <span className={`text-xs font-bold px-2 py-1 rounded-full ${hasBudget ? 'text-blue-700 bg-blue-100' : 'text-slate-600 bg-slate-100'}`}>
            {hasBudget ? 'Oui' : 'Non'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ScoreWidget;